export const environment = {
    production: true,
    staging: true,
    baseUrl: 'https://pe-central-api-staging.pozitivehub.com/',
    apiUrl: 'https://pe-sso.pozitivehub.com/api/',
    waterUrl:'http://157.245.44.23:9090/quotation/add',
    hubconnection: 'https://pe-sso.pozitivehub.com/api/emailVerifaction',
    redirectUrl :'https://pe-sso.pozitivehub.com',
    ssourl: "https://pe-sso.pozitivehub.com",
    authConfig: {
        authority: "https://pe-sso.pozitivehub.com/",
        redirectUrl: "https://pe-central-api-staging.pozitivehub.com/",
        postLogoutRedirectUri: 'https://pe-central-api-staging.pozitivehub.com/signout-callback-oidc',
        clientId: "central-spa-stag",
        scope: 'openid profile email roles offline_access',
        responseType: 'code',
        silentRenew: true,
        useRefreshToken: true,
    }
};
 